import React from 'react';
import { Switch, BrowserRouter, Redirect } from 'react-router-dom';
import LoginScreen from '../screens/login';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from '../screens/home';
import CardScreen from '../screens/cards';
import EditCardScreen from '../screens/cards/edit';
import HielocosScreen from '../screens/hielocos';
import UsersScreen from '../screens/users';
import { AnimatePresence } from 'framer-motion';
// Screens

export default function Routes() {
  return (
    <AnimatePresence exitBeforeEnter>
      <BrowserRouter>
        <Switch>
          <ProtectedRoute path={'/login'} exact>
            <LoginScreen />
          </ProtectedRoute>

          <PrivateRoute path={'/'} exact>
            <HomeScreen />
          </PrivateRoute>

          <PrivateRoute path={'/card'} exact>
            <CardScreen />
          </PrivateRoute>

          <PrivateRoute path={'/card/:id'} exact>
            <EditCardScreen />
          </PrivateRoute>

          <PrivateRoute path={'/poaps'} exact>
            <HielocosScreen />
          </PrivateRoute>

          <AdminRoute path={'/usuarios'} exact>
            <UsersScreen />
          </AdminRoute>

          <Redirect to={'/'} />
        </Switch>
      </BrowserRouter>
    </AnimatePresence>
  );
}
